// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__3d0q8","itemA":"Write_itemA__2kPzg","itemB":"Write_itemB__3fTtA","itemC":"Write_itemC__1Z67s","itemD":"Write_itemD__A7Lmr"};